module.exports = require("babel-polyfill");


//////////////////
// WEBPACK FOOTER
// external "babel-polyfill"
// module id = 1
// module chunks = 0